import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import SingleChat from '../Chat/SingleChat'
import { showPasswordlessLogin } from '../../libs/authService'
import Loader from '../UI/Loader'

import PropTypes from 'prop-types'
import get from 'lodash/get'
import _ from 'lodash'
import { isRTL } from '../../i18n'

import { DEFAULT_PROFILE_PIC_SRC } from './../../constants'

import TripDate from './TripDate'

import GET_CUSTOMIZED_PLAN from './../../graphql/TripPlanner/GetCustomizedPlan.graphql'

class MyTrip extends Component {

  static propTypes = {
    customizedPlanQuery: PropTypes.shape({
      CustomizedPlan: PropTypes.shape({
        tripGuru: PropTypes.shape({
          id: PropTypes.string
        }),
        orderingUser: PropTypes.shape({
          id: PropTypes.string
        })
      })
    }),
    history: PropTypes.object,
    t: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      chatIsShown: false
    }
  }

  authenticateToView() {
    window.localStorage.setItem('authRedirect', window.location.pathname)
    showPasswordlessLogin()
  }

  componentWillReceiveProps(next) {
    if (!this.props.expandAll) {
      /*
      if (!next.loading && !next.user) {
        this.authenticateToView()
      } else if (!next.customizedPlanQuery.loading && next.customizedPlanQuery.CustomizedPlan) {
      */
      if (!next.customizedPlanQuery.loading && next.customizedPlanQuery.CustomizedPlan) {
        const { customizedplan } = next.customizedPlanQuery

        const validIds = []

        if (customizedplan.tripGuru) {
          validIds.push(customizedplan.tripGuru.id)
        }

        if (customizedplan.orderingUser) {
          validIds.push(customizedplan.orderingUser.id)
        }

        if (next.user && validIds.indexOf(next.user.id) === -1) {
          this.props.history.push('/')
        }
      }
    }
    // If the plan completed its loading use it to set the viewing language
    if (!next.customizedPlanQuery.loading && this.props.customizedPlanQuery.loading) {
      if (next.customizedPlanQuery.customizedplan.orderingUser) {
        const lang = next.customizedPlanQuery.customizedplan.orderingUser.userProfile.defaultLanguage
        if (isRTL(lang)) {
          require('../../main_rtl.css')
        }
        else {
          require('../../main_ltr.css')
        }
      }
    }
  }

  handleMassageClick = () => {
    this.setState({
      chatIsShown: !this.state.chatIsShown
    })
  }

  renderGuruInfo() {
    const guru = get(this.props, 'customizedPlanQuery.customizedplan[0].tripGuru.userProfile', {})

    let result = ''

    result += get(guru, 'firstName', '')
    result += ' '
    result += get(guru, 'lastName', '')
    result += ', '
    result += get(guru, 'email', '')

    return result
  }

  renderTripDates() {
    const customizedPlan = get(this.props, 'customizedPlanQuery.customizedplan[0]', {})
    console.log('customizedPlan', customizedPlan)
    const days = get(customizedPlan, 'tripDetails.TripItinerarydays', [])
    console.log('days', days)
    return days.map((day, i) => <TripDate key={i} day={day.itineraryday} customizedPlanId={customizedPlan.id} expand={this.props.expandAll} user={this.props.user}/>)
  }

  render() {
    if (this.props.customizedPlanQuery.loading) {
        return <Loader showLoader={true} />
  
    }
    const orderingUserId = get(this.props, 'customizedPlanQuery.customizedplan[0].orderingUser.id')
    const guruId = get(this.props, 'customizedPlanQuery.customizedplan[0].tripGuru.id')
    const user = this.props.user
    return (
      <div className="container my-trip">
        <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 col-sm-12">
          <div className="my-trip__trip-guru">
            <img
              src={get(this.props, 'customizedPlanQuery.customizedplan[0].tripGuru.userProfile[0].imageAvatar.s3Url', DEFAULT_PROFILE_PIC_SRC)}
              className="trip-guru__avatar"
              alt="Trip Guru Avatar"
            />
            <div className="trip-guru__info" style={{ position: 'relative' }}>
              {this.renderGuruInfo()}
              {!this.props.expandAll && 
              <span className="trip-guru__click-to-message" style={{color:user&&(user.id !== orderingUserId||user.id !== guruId)||'#ccc'}} onClick={user&&(user.id !== orderingUserId||user.id !== guruId)&&this.handleMassageClick}>
                {this.props.t('send_message')}
                {this.state.chatIsShown && (
                  <SingleChat
                    user={user}
                    recipientId={user.id !== orderingUserId ? orderingUserId : guruId}
                    handleOpenChat={this.handleMassageClick}
                  />
                )}
              </span>
              }
            </div>
          </div>

          <hr />

          <div className="my-trip__trip-details">
            <img
              src={get(this.props, 'customizedPlanQuery.customizedplan[0].tripDetails.coverPhoto.s3Url', 'http://via.placeholder.com/800x300')}
              className="trip-details__photo"
              alt="Trip Photo"
            />

            <div className="trip-details__title">
              <span>{get(this.props, 'customizedPlanQuery.customizedplan[0].tripDetails.title', '')}</span>
            </div>

            <div
              className="trip-details__dates"
            >
              <span>{this.props.t('trip_dates')}</span>
            </div>

            {this.renderTripDates()}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(GET_CUSTOMIZED_PLAN, {
    name: 'customizedPlanQuery',
    options: props => ({
      variables: {
        id: props.match.params.id
      }
    })
  }),
  translate('my_trip')
)(MyTrip)



// WEBPACK FOOTER //
// src/components/MyTrip/index.js